import { useEffect, useState } from "react";
import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import HotRank from "@/pages/home/components/HotRank";
import BigNews from "@/pages/home/components/BigNews";
import CategoryFeed from "@/pages/home/components/CategoryFeed";
import FeatureTopics from "@/pages/home/components/FeatureTopics";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import ContactForm from "@/pages/home/components/ContactForm";
import Footer from "@/pages/home/components/Footer";
import { faqs, bigNews } from "@/mocks/chaqua";

const SITE_URL = "https://inmade-casting.cn/";

function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export default function Home() {
  const [activeCat, setActiveCat] = useState("all");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const org = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "吃瓜在线",
    url: SITE_URL,
    description: "吃瓜在线今日热点速览，实时汇总今日大瓜、今日热议与今日新鲜事。",
    inLanguage: "zh-CN",
  };

  const page = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "今日大瓜·今日热议·今日新鲜事速览",
    url: SITE_URL,
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: "吃瓜在线", url: SITE_URL },
  };

  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日大瓜精选",
    itemListElement: bigNews.map((n) => ({
      "@type": "ListItem",
      position: n.id,
      name: n.title,
      url: `${SITE_URL}#big`,
    })),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div id="top" className="min-h-screen bg-cream-50 text-stone-800">
      <JsonLd data={org} />
      <JsonLd data={page} />
      <JsonLd data={itemList} />
      <JsonLd data={faqSchema} />

      <Header />
      <main>
        <Hero activeCat={activeCat} onPickCat={setActiveCat} />
        <HotRank />
        <BigNews />
        <CategoryFeed activeCat={activeCat} onPickCat={setActiveCat} />
        <FeatureTopics />
        <About />
        <Faq />
        <ContactForm />
      </main>
      <Footer />

      <a
        href="#top"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-stone-900 text-lg text-white shadow-lg transition-all hover:bg-coral-500 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line" aria-hidden="true"></i>
      </a>
    </div>
  );
}